import { Component, OnInit, Input } from '@angular/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { TranslationEntry } from '@app/shared/models/translatable';

@Component({
  selector: 'quick-detailed-switch',
  templateUrl: './quick-detailed-switch.component.html',
  styleUrls: ['./quick-detailed-switch.component.scss']
})
export class QuickDetailedSwitchComponent extends BaseWithBundleComponent implements OnInit {

  @Input()
  private caseId;

  public options: TranslationEntry[] = [
    {
      trans: marker('case.navigation.quick'),
      key: 'quick-processing'
    },
    {
      trans: marker('case.navigation.detailed'),
      key: 'details'
    }
  ];

  public selected: TranslationEntry;

  constructor(protected componentServiceBundle: ComponentServiceBundle) {
    super(componentServiceBundle);
  }

  public ngOnInit() {
    this.selected = this.router.url.indexOf(this.options[0].key) > -1 ? this.options[0] : this.options[1];

    this.options.forEach(option => {
      this.subscriptions.push(
          this.translateService.get(option.trans)
                               .subscribe(trans => {
           console.warn(trans);
            option.trans = trans;
          })
      );
    });
  }

  public onSelectionChange(): void {
    const suffix = this.selected.key;
    this.router.navigateByUrl(`case/${this.caseId}/${suffix}`);
  }
}
